import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import {WizardComponent} from "./wizard/wizard.component";

export const routes: Routes = [
  // { path: '', redirectTo: 'admin', pathMatch: 'full' },
  // { path: 'admin', loadChildren: 'app/admin/pages/pages.module#PagesModule' },
  { path: '', component: WizardComponent },
  { path: 'offers/:id', component: WizardComponent },
  { path: 'offers/:id/edit', component: WizardComponent, data: {action: 'edit'} },
  // { path: 'register', loadChildren: 'app/pages/register/register.module#RegisterModule' },
  { path: '**', redirectTo: '' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
   // useHash: true
});



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/app.routing.ts